// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1Oc4O","log":"ModalInventoryLogs_log__n1Fe7","date":"ModalInventoryLogs_date__35AQS","userName":"ModalInventoryLogs_userName__3GaVg"};